// Per-tier upload size limits in bytes.
// Mirror of workers/shared/tier-limits.ts. Keep values in sync.
export const TIER_UPLOAD_LIMITS: Record<'free' | 'pro' | 'business', number> = {
  free: 50 * 1024 * 1024,            // 50 MB
  pro: 1 * 1024 * 1024 * 1024,       // 1 GB
  business: 20 * 1024 * 1024 * 1024, // 20 GB
}

export type Tier = keyof typeof TIER_UPLOAD_LIMITS

export function tierMaxBytes(tier: string | null | undefined): number {
  if (tier === 'pro' || tier === 'business' || tier === 'free') {
    return TIER_UPLOAD_LIMITS[tier]
  }
  return TIER_UPLOAD_LIMITS.free
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`
  if (bytes < 1024 * 1024 * 1024) return `${Math.round(bytes / (1024 * 1024))} MB`
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`
}
